/* eslint react/forbid-prop-types: 0 */
/* global globals */
import React, { Component } from 'react';
import get from 'lodash/get';
import scrollAnimation from '../helpers/scrollAnimation';
import popup from '../legacy/app/popup';
import PaymentsStore from './stores/PaymentsStore';
import { PaymentsProgressBar, PaymentsTitle } from './components/payments';
import { SubscriptionTermsContainer, PaymentOptionsContainer } from './containers';
import gtm from '../helpers/gtm';

class PaymentsApp extends Component {
  state = {
    active: PaymentsStore.getActive(),
  };

  constructor(props) {
    super(props);

    PaymentsStore.setInitialData();
    PaymentsStore.addActiveChangeListener(this.onActiveChange);
  }

  componentDidMount() {
    if (!PaymentsStore.getCouponCode()) {
      this.handleAutoScroll();
    }
    this.handlePopup();
    this.handleUrlQuery();
    this.onActiveChange();
  }

  componentDidUpdate() {
    this.handleAutoScroll();
    this.handleUrlQuery();
  }

  onActiveChange = () => {
    const active = PaymentsStore.getActive();
    this.setState({ active });
    if (!active) {
      return;
    }

    const type = PaymentsStore.getType();
    const terms = PaymentsStore.getTerms();
    if (!type || !terms[active]) {
      return;
    }

    gtm.trackEcommerce('add_to_cart', type, active, terms[active]);
  };

  onCheckout = (e, adapter) => {
    e.preventDefault();

    const { active } = this.state;
    const type = PaymentsStore.getType();
    const terms = PaymentsStore.getTerms();
    if (active && type && terms[active]) {
      gtm.trackEcommerce('begin_checkout', type, active, terms[active], adapter);
    }

    window.location.href = e.currentTarget.href;
  };

  handlePopup = () => {
    if (PaymentsStore.getPopup() === 'subscriptionMessage') {
      popup.subscriptionMessage();
    }
    if (PaymentsStore.getPopup() === 'adminMessages') {
      popup.adminMessages();
    }
  };

  handleAutoScroll = () => {
    const scrollTarget = document.querySelector('.paymentOption-container');
    if (scrollTarget) {
      scrollAnimation(scrollTarget, 210);
    }
  };

  handleUrlQuery = () => {
    PaymentsStore.updateUrlQuery();
    // Supports pushState (skip for 'highlight')
    if (window.history.pushState && PaymentsStore.getType() !== 'highlight') {
      window.history.pushState({}, '', PaymentsStore.getUrlQuery());
    }
  };

  render() {
    const type = PaymentsStore.getType();
    const terms = PaymentsStore.getTerms();
    const { active } = this.state;
    const countdownFormat = get(globals, 'campaignCountdownFormat', 'DHMS');
    const { verificationStatus } = this.props;

    return (
      <div className="paymentContainer pbxl">
        <PaymentsProgressBar
          active={active}
          type={type}
          sms={get(terms[active], 'type') === 'sms'}
          verificationStatus={verificationStatus}
        />
        <PaymentsTitle />
        {get(globals, 'campaignEndtime', '') && (
          <div
            className={`campaign-countdown campaign-countdown--big ${countdownFormat === 'HMS' ? 'campaign-countdown--nodays' : ''} tac mbm`}
          >
            <div
              className="campaign-countdown-inner dib"
              data-countdown-format={countdownFormat}
            />
          </div>
        )}
        {(type === 'subscription' || type === 'subscription_other') && (
          <SubscriptionTermsContainer
            type={type}
            terms={terms}
            active={active}
          />
        )}
        <PaymentOptionsContainer
          type={type}
          data={terms[active]}
          active={active}
          onCheckout={this.onCheckout}
        />
      </div>
    );
  }
}

export default PaymentsApp;
